module.exports = __webpack_public_path__ + "static/media/soil_profile.df9324c3.png";